export enum AgentType {
  JobBroker = "JobBroker",
  Ingest = "Ingest",
  FileAccessor = "FileAccessor",
  EmailNotification = "EmailNotification",
  EventNotifier = "EventNotifier",
  CacheManager = "CacheManager",
  DataExporter = "DataExporter",
  OrderProcessor = "OrderProcessor",
  WorkflowHandler = "WorkflowHandler",
  MetadataChecker = "MetadataChecker",
  ThumbnailServer = "ThumbnailServer",
  FileDeamon = "FileDeamon",
  AuthotDriver = "AuthotDriver",
  EzConvertDriver = "EzConvertDriver",
  DivaDriver = "DivaDriver",
  StornextDriver = "StornextDriver",
  AmberfinIcrDriver = "AmberfinIcrDriver",
  AsperaDriver = "AsperaDriver",
  VantageDriver = "VantageDriver",
  BatonDriver = "BatonDriver",
  SpockUnity = "SpockUnity",
  SpockIron = "SpockIron",
  SpockConnect = "SpockConnect",
}
